module.exports = __webpack_public_path__ + "static/img/audio_close.0c81f05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/audio_close.png
// module id = 2tuq
// module chunks = 0